<script lang="ts" setup>
  import { ref } from 'vue';
  import { reasonOf } from '../../../../shared/api/client.ts';
  import { pauseGame, unpauseGame } from '../../../../shared/api/game.ts';
  import { startUserAction, userAction } from '../../../../shared/observability/userAction.ts';
  import { useRefuse } from '../../model/refusal.ts';
  import HostPauseButton from './HostPauseButton.vue';

  const props = defineProps<{ paused: boolean }>();
  const emit = defineEmits<{ toggled: [] }>();

  const refuse = useRefuse();
  const isPosting = ref(false);

  const toggle = async () => {
    if (isPosting.value) return;

    isPosting.value = true;
    try {
      if (props.paused) {
        startUserAction(userAction.roundUnpause);
        await unpauseGame();
      } else {
        startUserAction(userAction.roundPause);
        await pauseGame();
      }
      emit('toggled');
    } catch (error) {
      refuse(reasonOf(error));
    } finally {
      isPosting.value = false;
    }
  };
</script>

<template>
  <HostPauseButton :paused="paused" :posting="isPosting" @toggle="toggle" />
</template>
